import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import config from 'config';
import Alert from 'react-s-alert';
import Modal from 'react-modal';
import styled, { ThemeProvider } from 'styled-components';

// Actions & services & constants
import { loginSuccess, refreshTokenExpired, addPractitioner } from 'src/store/auth/actions';
import { ROLES } from 'services/constants';
import { normalizeToken } from 'services/functions';
import { openInWebView } from 'views/patient/services';
import { initMetrics } from './services/analytics';

// Polyfills
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

// Components
import AlertTemplate from 'components/AlertTemplate';
import TimerDebug from 'src/components/TimerDebug';

// Themes
import orthoca from './styles/themes/orthoca';
import azmonica from './styles/themes/azmonica';
import GlobalStyle from './styles/globalStyle';

import { connect } from 'react-redux';

Modal.setAppElement('#app');

const Container = styled.div`
  height: 100%;
`;

class App extends Component {
  constructor() {
    super();
    this.checkExpireTime = this.checkExpireTime.bind(this);
    this.state = {
      initAction: null
    };
    // clear all tokens when open in mobile app
    if (openInWebView) {
      localStorage.clear();
    }
  }

  componentDidMount() {
    const { authSuccess } = this.props;
    const tokenData = JSON.parse(localStorage.getItem('token'));
    const role = localStorage.getItem('um_role');
    if (tokenData) {
      authSuccess(tokenData, role);
      if (role === ROLES.STAFF ||
        role === ROLES.RADIOLOGY ||
        role === ROLES.PRACTITIONER
      ) {
        this.props.addPractitioner(normalizeToken(tokenData.access_token));
      }
    }

    setInterval(this.checkExpireTime, 15000);
    document.addEventListener('click', () => this.reset());
    document.addEventListener('keypress', () => this.reset());
  }

  reset() {
    const {
      auth: { exp, nbf }
    } = this.props;

    if (exp && nbf) {
      this.setState({ initAction: new Date().valueOf() });
    }
  }

  componentDidUpdate({ location }) {
    if (this.props.location !== location) {
      window.scrollTo(0, 0);
    }
  }

  checkExpireTime() {
    const {
      auth: { exp, nbf }
    } = this.props;
    const { initAction } = this.state;

    if (exp && nbf) {
      !initAction && this.setState({ initAction: new Date().valueOf() });
      let isExpireSession =
        (exp - nbf) * 2 + (initAction || new Date().valueOf()) < new Date().valueOf();
      if (isExpireSession) {
        this.setState({ initAction: null });
        this.props.refreshTokenExpired();
      }
    }
  }

  render() {
    const isDevBuild = config && config.api && config.api.match(/dev/);
    return (
      <ThemeProvider theme={global.theme.orgType === 'azmonica' ? azmonica : orthoca}>
        <Container>
          <GlobalStyle />
          {this.props.children}
          {// init analytics module (need include to render for YM)
            initMetrics()}
          <Alert stack={{ limit: 5 }} timeout={5000} contentTemplate={AlertTemplate} />
          {isDevBuild ? <TimerDebug /> : null}
        </Container>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth
});

const mapDispatchToProps = dispatch => ({
  authSuccess: (tokenData, role) => dispatch(loginSuccess(tokenData, role)),
  refreshTokenExpired: () => dispatch(refreshTokenExpired()),
  addPractitioner: practitioner => dispatch(addPractitioner(practitioner))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);
